module.exports = __webpack_public_path__ + "static/media/requestsHome.cd5e974b.svg";